var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-arrow-alt-circle-up scroll-up",class:{
    show: _vm.visible,
    'scroll-up--sticky': _vm.emulateStickyBehavior,
    'scroll-up--sticky-disabled': !_vm.emulateStickyBehavior
  },on:{"click":function($event){return _vm.scrollPageToTop()}}})}
var staticRenderFns = []

export { render, staticRenderFns }